export const TIME_RANGE_PICKER_TAG_NAME = "time-range-picker" as const;

export const OVERLAP_MODES = ["forbid", "stack"] as const;

export const DEFAULT_MIN = "06:00";

export const DEFAULT_MAX = "20:00";

export const DEFAULT_STEP = 5;

export const DEFAULT_MAJOR_TICK = 120;

export const DEFAULT_MINOR_TICK = 60;

export const TRACK_HEIGHT = 96;

export const HANDLE_WIDTH = 8;

export const OVERVIEW_HEIGHT = 28;

export const MIN_VIEW = 15;

export const MAJOR_TICK_TARGET = 6;

export const MINOR_TICK_TARGET = 12;
